export let dashboardKey;
export const setDashboardKey = value => dashboardKey = value;

export const emptyCard = () => ({ name: "Empty", size: "sm", });
